import { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Collapse,
  Spinner,
} from "reactstrap";
import * as XLSX from "xlsx";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import { getAttendeesReport } from "../../../utils/services/attendeeVibra";
import { connect } from "react-redux";
import SuperChart from "./superChart";

const DashboardVibra = (props) => {
  const [attendeesReport, setAttendeesReport] = useState([]);
  const token = props.state?.global_user_data.data.token;
  const [loading, setLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [downloadText, setDownloadText] = useState("Exportar Planilha");

  const normalizeCNPJ = (cnpj) => cnpj?.replace(/[^\d]/g, "") || "";

  const revendedoresPorCNPJ = attendeesReport.reduce((acc, item) => {
    const cnpj = normalizeCNPJ(item["CNPJ"]);
    if (!cnpj) return acc;

    if (!acc[cnpj]) acc[cnpj] = [];
    acc[cnpj].push(item);
    return acc;
  }, {});

  const CNPJsInscritos = Object.keys(revendedoresPorCNPJ).filter((cnpj) =>
    revendedoresPorCNPJ[cnpj].some(
      (p) => p["CPF"] && p["CPF"].toString().trim() !== ""
    )
  );

  const isInscrito = (item) => {
    const cpf = item["CPF"]?.toString().trim();
    const cnpj = normalizeCNPJ(item["CNPJ"]);

    if (item["Tipo de Cadastro"] !== "Revendedor") {
      return cpf && cpf !== "";
    }

    if (cnpj && CNPJsInscritos.includes(cnpj)) {
      return true;
    }

    return false;
  };

  const inscritos = attendeesReport.filter(isInscrito);
  const pendentes = attendeesReport.filter((item) => !isInscrito(item));

  useEffect(() => {
    console.log({ inscritos, pendentes });
  }, [pendentes, inscritos]);

  const inscritosTimeVibra = inscritos.filter(
    (x) => x["Tipo de Cadastro"] === "TIME VIBRA"
  ).length;

  const inscritosRevendedor = inscritos.filter(
    (x) => x["Tipo de Cadastro"] === "Revendedor"
  ).length;

  const inscritosConvidado = inscritos.filter(
    (x) => x["Tipo de Cadastro"] === "Convidado"
  ).length;

  const pendentesTimeVibra = pendentes.filter(
    (x) => x["Tipo de Cadastro"] === "TIME VIBRA"
  ).length;

  const pendentesRevendedor = pendentes.filter(
    (x) => x["Tipo de Cadastro"] === "Revendedor"
  ).length;

  const pendentesConvidado = pendentes.filter(
    (x) => x["Tipo de Cadastro"] === "Convidado"
  ).length;

  const exportExcel = () => {
    setIsDownloading(true);
    setDownloadText("Processando...");

    const wb = XLSX.utils.book_new();

    const insertClothingFields = (item, afterField) => {
      const ordered = {};

      const clothingFields = {
        Camisa: item["Camisa"] || "",
        "Modelo de camisa": item["Modelo de camisa"] || "",
        "Tamanho de camisa": item["Tamanho de camisa"] || "",
        Casaco: item["Casaco"] || "",
        "Tamanho Casaco": item["Tamanho Casaco"] || "",
      };

      const keys = Object.keys(item);

      keys.forEach((key) => {
        ordered[key] = item[key];

        if (key === afterField) {
          Object.assign(ordered, clothingFields);
        }
      });

      return ordered;
    };

    const reorderForExport = (data) => {
      return data.map((item) => insertClothingFields(item, "Empresa"));
    };

    const timeVibraInscritos = reorderForExport(
      inscritos.filter((x) => x["Tipo de Cadastro"] === "TIME VIBRA")
    );

    const timeVibraPendentes = reorderForExport(
      pendentes.filter((x) => x["Tipo de Cadastro"] === "TIME VIBRA")
    );

    const revendedorInscritos = reorderForExport(
      inscritos.filter((x) => x["Tipo de Cadastro"] === "Revendedor")
    );

    const revendedorPendentes = reorderForExport(
      pendentes.filter((x) => x["Tipo de Cadastro"] === "Revendedor")
    );

    const convidadoInscritos = reorderForExport(
      inscritos.filter((x) => x["Tipo de Cadastro"] === "Convidado")
    );

    const convidadoPendentes = reorderForExport(
      pendentes.filter((x) => x["Tipo de Cadastro"] === "Convidado")
    );

    const ws1 = XLSX.utils.json_to_sheet(timeVibraInscritos);
    const ws2 = XLSX.utils.json_to_sheet(timeVibraPendentes);
    const ws3 = XLSX.utils.json_to_sheet(revendedorInscritos);
    const ws4 = XLSX.utils.json_to_sheet(revendedorPendentes);
    const ws5 = XLSX.utils.json_to_sheet(convidadoInscritos);
    const ws6 = XLSX.utils.json_to_sheet(convidadoPendentes);

    XLSX.utils.book_append_sheet(wb, ws1, "Time Vibra - Inscritos");
    XLSX.utils.book_append_sheet(wb, ws2, "Time Vibra - Pendentes");
    XLSX.utils.book_append_sheet(wb, ws3, "Revendedor - Inscritos");
    XLSX.utils.book_append_sheet(wb, ws4, "Revendedor - Pendentes");
    XLSX.utils.book_append_sheet(wb, ws5, "Convidados - Inscritos");
    XLSX.utils.book_append_sheet(wb, ws6, "Convidados - Pendentes");

    setTimeout(() => {
      XLSX.writeFile(wb, "Relatorio_Detalhado_Inscritos_Pendentes.xlsx");
      setIsDownloading(false);
      setDownloadText("Exportar Planilha");
    }, 300); // evita travar a UI
  };

  async function getAttendeesReportDashboard() {
    try {
      const res = await getAttendeesReport(token);
      setAttendeesReport(res);
    } catch (err) {
      console.error("Erro ao buscar relatório de participantes:", err);
    } finally {
      setLoading(true);
      setTimeout(() => setLoading(false), 600);
    }
  }

  const normalizeDate = (dateString) => {
    if (!dateString) return null;

    const [date, time] = dateString.split(" ");
    if (!date) return null;

    const [day, month, year] = date.split("/");
    if (!day || !month || !year) return null;

    return `${year}-${month}-${day}`;
  };

  const inscritosPorDiaGrupo = inscritos.reduce((acc, item) => {
    const rawDate = item["Data de cadastro"];
    const normalized = normalizeDate(rawDate);
    if (!normalized) return acc;

    if (!acc[normalized]) {
      acc[normalized] = {
        funcionario: 0,
        revendedor: 0,
        convidado: 0,
      };
    }

    const tipo = item["Tipo de Cadastro"];

    if (tipo === "TIME VIBRA") acc[normalized].funcionario++;
    if (tipo === "Revendedor") acc[normalized].revendedor++;
    if (tipo === "Convidado") acc[normalized].convidado++;

    return acc;
  }, {});

  const inscritosByDay = Object.keys(inscritosPorDiaGrupo)
    .sort()
    .map((d) => ({
      date: d,
      funcionario: inscritosPorDiaGrupo[d].funcionario,
      revendedor: inscritosPorDiaGrupo[d].revendedor,
      convidado: inscritosPorDiaGrupo[d].convidado,
    }));

  useEffect(() => {
    console.log({ inscritosByDay });
  }, [attendeesReport]);

  useEffect(() => {
    getAttendeesReportDashboard();
  }, []);

  if (loading) {
    return (
      <Card>
        <CardBody
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "40vh",
            flexDirection: "column",
          }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          <p style={{ marginTop: 15, fontSize: 16, color: "#555" }}>
            Carregando dados...
          </p>
        </CardBody>
      </Card>
    );
  }

  return (
    <>
      <Card>
        <CardBody>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
              marginBottom: 10,
            }}
          >
            <div className="header-btns-container">
              <Button
                color="success"
                disabled={isDownloading}
                className="btn-rounded waves-effect waves-light events-button-add-lg"
                onClick={() => {
                  if (!isDownloading) exportExcel();
                }}
              >
                {downloadText}
              </Button>
            </div>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />

              <Collapse isOpen={isOpen}>
                <Row
                  className="mobile-btns-top"
                  onClick={() => {
                    if (!isDownloading) exportExcel();
                  }}
                >
                  <div style={{ opacity: isDownloading ? 0.6 : 1 }}>
                    {downloadText}
                  </div>
                </Row>
              </Collapse>
            </div>
          </div>

          <CardTitle>Totalizadores</CardTitle>

          <Row style={{ marginTop: 20 }}>
            <h5>Cadastrados</h5>
          </Row>

          <Row style={{ margin: "20px 0" }}>
            <Col
              md={12}
              className="logistic-all-topics"
              style={{ flexWrap: "wrap" }}
            >
              <div
                className="logistic-topic card-shadow"
                style={{
                  background:
                    "linear-gradient(45deg, rgb(52, 199, 89) 0%, rgb(114 241 146) 100%)",
                }}
              >
                <h4
                  className="logistics-title-topic"
                  style={{ color: "black" }}
                >
                  Time Vibra
                </h4>
                <a style={{ color: "black" }}>{inscritosTimeVibra}</a>
              </div>

              <div
                className="logistic-topic card-shadow"
                style={{
                  background:
                    "linear-gradient(45deg, rgb(255, 193, 7) 0%, #ffe596 100%)",
                }}
              >
                <h4
                  className="logistics-title-topic"
                  style={{ color: "black" }}
                >
                  Revendedor
                </h4>
                <a style={{ color: "black" }}>{inscritosRevendedor}</a>
              </div>

              <div
                className="logistic-topic card-shadow"
                style={{
                  background:
                    "linear-gradient(45deg, rgb(142, 36, 170) 0%, rgb(193 86 221) 100%)",
                }}
              >
                <h4
                  className="logistics-title-topic"
                  style={{ color: "black" }}
                >
                  Convidado
                </h4>
                <a style={{ color: "black" }}>{inscritosConvidado}</a>
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 50 }}>
            <h5>Pendentes de Cadastro</h5>
          </Row>

          <Row style={{ margin: "20px 0" }}>
            <Col
              md={12}
              className="logistic-all-topics"
              style={{ flexWrap: "wrap" }}
            >
              <div
                className="logistic-topic card-shadow"
                style={{
                  background:
                    "linear-gradient(45deg, rgb(52, 199, 89) 0%, rgb(114 241 146) 100%)",
                }}
              >
                <h4
                  className="logistics-title-topic"
                  style={{ color: "black" }}
                >
                  Time Vibra
                </h4>
                <a style={{ color: "black" }}>{pendentesTimeVibra}</a>
              </div>

              <div
                className="logistic-topic card-shadow"
                style={{
                  background:
                    "linear-gradient(45deg, rgb(255, 193, 7) 0%, #ffe596 100%)",
                }}
              >
                <h4
                  className="logistics-title-topic"
                  style={{ color: "black" }}
                >
                  Revendedor
                </h4>
                <a style={{ color: "black" }}>{pendentesRevendedor}</a>
              </div>

              <div
                className="logistic-topic card-shadow"
                style={{
                  background:
                    "linear-gradient(45deg, rgb(142, 36, 170) 0%, rgb(193 86 221) 100%)",
                }}
              >
                <h4
                  className="logistics-title-topic"
                  style={{ color: "black" }}
                >
                  Convidado
                </h4>
                <a style={{ color: "black" }}>{pendentesConvidado}</a>
              </div>
            </Col>
          </Row>

          <Row style={{ margin: "20px 0" }}>
            <Col md={12}>
              <SuperChart dataByDay={inscritosByDay} />
            </Col>
          </Row>

          {/* <Row>
            <Col md={12}>
              <LineChart
                dataByDay={inscritosByDay}
                dataEvolution={inscritosByDay}
              />
            </Col>
          </Row> */}
        </CardBody>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({ state });

export default connect(mapStateToProps)(DashboardVibra);
